// extracted by mini-css-extract-plugin
export default {"empty":"NotFound_empty__FX4xE"};